import React from 'react';
import ReactLinkify, { Props as ReactLinkifyProps } from 'react-linkify';
import classNames from 'classnames';

type Props = ReactLinkifyProps & {
  children: React.ReactNode | React.ReactNode[];
  css?: {
    link?: string;
  };
};

export const Linkify = (props: Props) => {
  const { children, css } = props;
  const componentDecorator: Props['componentDecorator'] = (
    href: string,
    text: string,
    key: number,
  ) => (
    <a
      className={classNames('linkify--link', css?.link)}
      href={href}
      key={key}
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
    </a>
  );

  return (
    <ReactLinkify {...props} componentDecorator={componentDecorator}>
      {children}
    </ReactLinkify>
  );
};
